import { useConsentSelector, UserConsentsNames } from "@nf/common";
import dynamic from "next/dynamic";
import Script from "next/script";
import { useEffect, useState } from "react";

import { useLanguage } from "hooks";
import { GoogleTagManager } from "../GoogleTagManager";
import { GTM_ID } from "lib/gtm";

const NewRelicMonitoring = dynamic(
  () => import("components/NewRelicMonitoring")
);

const PlayablePopupObserver = dynamic(
  () => import("components/PlayablePopupObserver")
);

const COOKIE_CONSENT_ID = "CookieConsent";

export const CookieConsent = () => {
  const [cookieConsentLoaded, setCookieConsentLoaded] = useState(false);
  const { consent: marketingConsent } = useConsentSelector(
    UserConsentsNames.Marketing
  );

  const language = useLanguage();
  const dataCulture = language.toUpperCase();

  useEffect(() => {
    const dataCultureAttr = document
      .getElementById(COOKIE_CONSENT_ID)
      ?.getAttribute("data-culture");

    if (dataCultureAttr !== dataCulture) {
      document
        .getElementById(COOKIE_CONSENT_ID)
        ?.setAttribute("data-culture", dataCulture);
    }
  }, [dataCulture]);

  const onScriptLoad = () => {
    setCookieConsentLoaded(true);
  };

  return (
    <>
      <Script
        id={COOKIE_CONSENT_ID}
        src="https://policy.app.cookieinformation.com/uc.js"
        data-consent-src="https://policy.app.cookieinformation.com/uc.js"
        data-culture={dataCulture}
        data-gcm-version="2.0"
        onLoad={onScriptLoad}
        type="text/javascript"
        strategy="lazyOnload"
      />
      {cookieConsentLoaded && GTM_ID && <GoogleTagManager />}
      {cookieConsentLoaded && <NewRelicMonitoring />}
      {marketingConsent?.Accepted === false && <PlayablePopupObserver />}
    </>
  );
};

export default CookieConsent;
